// @ts-nocheck
import { useLeaveBalanceRepository } from '../repositories';
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import {
  LEAVE_BALANCES_QUERY,
  LEAVE_TRANSACTIONS_QUERY,
  ADJUST_LEAVE_BALANCE_MUTATION,
  TEAM_LEAVE_SUMMARY_QUERY,
} from '../graphql/operations';

// ── Types ───────────────────────────────────────────────────────────────────

export interface LeaveBalance {
  id: string;
  employeeId: string;
  employeeName: string;
  leaveType: string;
  policyId?: string;
  policyName?: string;
  accrued: number;
  used: number;
  pending: number;
  available: number;
  carryover: number;
  maxAccrual?: number;
  accrualRate?: number;
  accrualPeriod?: string;
  nextAccrualDate?: string;
  yearStart: string;
  yearEnd: string;
}

export interface LeaveTransaction {
  id: string;
  employeeId: string;
  leaveType: string;
  transactionType: 'ACCRUAL' | 'USAGE' | 'ADJUSTMENT' | 'CARRYOVER' | 'FORFEIT' | 'PAYOUT';
  hours: number;
  balanceAfter: number;
  date: string;
  description: string;
  requestId?: string;
  approvedBy?: string;
  createdAt: string;
}

interface TeamLeaveSummaryItem {
  employeeId: string;
  employeeName: string;
  department: string;
  balances: { leaveType: string; available: number; used: number; pending: number }[];
}

// ── Basic List Hook (via Repository) ──────────────────────────────────────

export function useLeaveBalances(employeeId?: string) {
  const repo = useLeaveBalanceRepository();
  return repo.useList({ employeeId });
}

// ── Specialized Hooks (via useApolloCompat) ───────────────────────────────

export function useLeaveTransactions(
  employeeId: string,
  leaveType?: string,
  startDate?: string,
  endDate?: string,
) {
  return useCompatQuery(LEAVE_TRANSACTIONS_QUERY, {
    variables: { employeeId, leaveType, startDate, endDate },
    skip: !employeeId,
  });
}

export function useAdjustLeaveBalance() {
  return useCompatMutation(ADJUST_LEAVE_BALANCE_MUTATION, {
    refetchQueries: [
      { query: LEAVE_BALANCES_QUERY },
      { query: LEAVE_TRANSACTIONS_QUERY },
    ],
  });
}

export function useTeamLeaveSummary(departmentId?: string, date?: string) {
  return useCompatQuery(TEAM_LEAVE_SUMMARY_QUERY, {
    variables: { departmentId, date },
  });
}
